import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { cleanState, fetchExportOptions, exportRoute, hideExportDialog } from '@Pages/RetroSynthesis/ExportRoute/actions';
import ExportRouteDialog, { ExportTab } from '@Pages/RetroSynthesis/ExportRoute/ExportRouteDialog';
import { response as route, selectedExamplesCount } from '@Pages/RetroSynthesis/ProjectRoute/selectors';
import { useLocation, useParams } from 'react-router-dom';
import { RouteType } from '@Pages/RetroSynthesis/constants';
import { exportState, tabs } from '@Pages/RetroSynthesis/ExportRoute/selectors';
import UserDatabases from '@Services/UserDatabases';
import { onExportPopupOpened, onExportStarted } from '@Pages/RetroSynthesis/ExportRoute/analytics';
import { getPageNameByPath } from '@Pages/RetroSynthesis/ProjectRoute/ProjectRouteToolbar/ProjectRouteToolbarContainer';
import { ExportRTSelections } from '@Pages/RetroSynthesis/ExportRoute/components/ExportSelection';
import { getProjectsInfoMap } from '@Pages/RetroSynthesis/RsBreadcrumbs/selector';
import { buildStepsData } from '@Pages/RetroSynthesis/ProjectRoute/utils/conditionsDataBuilder';
/* eslint-disable react/prop-types */
/* eslint-disable no-shadow */
/* eslint-disable react-hooks/exhaustive-deps */
function ExportRouteDialogContainer({
  fetchExportOptions,
  cleanState,
  exportRoute,
  hideExportDialog,
  isBusy,
  isLoading,
  tabs,
  route,
  response,
  selectedExamplesCount,
  projectsInfoMap,
}) {
  const { projectId } = useParams();
  const location = useLocation();
  const [pageName, setPageName] = useState(getPageNameByPath(location.pathname));
  const projectInfo = projectsInfoMap && projectsInfoMap[projectId];

  useEffect(() => {
    setPageName(getPageNameByPath(location.pathname));
  }, [location]);

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (!isBusy && route && route.routeLayout) {
      let reactions = {};
      if (RouteType.PUBLISHED === route.routeType) {
        reactions = route.routeLayout
          .filter((route) => route.reaction && route.reaction.reactionId && route.reaction.databaseId)
          .reduce((result, route) => {
            if (!result[route.reaction.databaseId]) {
              // eslint-disable-next-line no-param-reassign
              result[route.reaction.databaseId] = [];
            }
            if (result[route.reaction.databaseId].indexOf(route.reaction.reactionId) < 0) {
              result[route.reaction.databaseId].push(route.reaction.reactionId);
            }
            return result;
          }, {});
      } else {
        const databaseId = UserDatabases.getDefaultDatabase().id;
        reactions = route.routeLayout
          .filter((route) => route.examples && route.examples.length)
          .reduce((result, route) => {
            if (!result[databaseId]) {
              // eslint-disable-next-line no-param-reassign
              result[databaseId] = [];
            }
            route.examples.forEach((example) => {
              if (result[databaseId].indexOf(example.reactionId) < 0) {
                result[databaseId].push(example.reactionId);
              }
            });
            return result;
          }, {});
      }

      // action
      fetchExportOptions(reactions);

      // AA tracking
      onExportPopupOpened({ projectId, route, pageName, projectInfo });
      return () => {
        cleanState();
      };
    }
  }, [route]);

  const onExport = (tabData) => {
    const databaseId = UserDatabases.getDefaultDatabase().id;
    const selectedOnly = tabData.rtSelection === ExportRTSelections.SELECTED_ONLY;
    const params = {
      projectId,
      routeNo: route.id,
      databaseId,
      items: [],
      range: '1-1',
      plannerTree: {},
      docFormat: tabData.selectedFormat.value,
      options: tabData.additionalOptions,
      headline: tabData.headline,
      selectedOnly,
    };
    const noEntities = {};
    noEntities[databaseId] = { databaseId, resultName: undefined };
    // Attach search result object
    let searchInfo = {};
    if (tabData.currentTabIndex === ExportTab.REACTIONS) {
      searchInfo = response.reactionsEntities || noEntities;
      params.sortField = 'RX.RANK';
      params.sortOrder = 'desc';
      params.template = 'NewSynthesisPlan';
    }
    if (tabData.selectedFormat.export_options) {
      params.options = params.options.concat(tabData.selectedFormat.export_options.map((o) => o.name));
    }
    params.results = {};
    params.results[databaseId] = searchInfo[databaseId].resultName;
    params.resultName = searchInfo[databaseId].resultName;

    // action
    exportRoute(params);

    const steps = buildStepsData(route);
    const examplesCount = steps.reduce(
      (count, step) => (step.examples && step.examples.filter((e) => (selectedOnly ? e.selected : true)).length + count) || count,
      0
    );
    const count = examplesCount > 0 ? examplesCount : 1;
    // AA tracking
    onExportStarted({ projectId, route, pageName, format: params.docFormat, projectInfo, count, selectedOnly });
  };

  return (
    <ExportRouteDialog
      onExport={onExport}
      onClose={hideExportDialog}
      isBusy={isBusy}
      isLoading={isLoading}
      tabs={tabs}
      disableSelectionOptions={selectedExamplesCount === 0}
    />
  );
}

function mapStateToProps(state) {
  const { isLoading, response, error, isBusy } = exportState(state);
  return {
    isLoading,
    isBusy,
    error,
    response,
    route: route(state),
    tabs: tabs(state),
    selectedExamplesCount: selectedExamplesCount(state),
    projectsInfoMap: getProjectsInfoMap(state),
  };
}

const mapDispatchToProps = {
  fetchExportOptions,
  exportRoute,
  cleanState,
  hideExportDialog,
};

export default connect(mapStateToProps, mapDispatchToProps)(ExportRouteDialogContainer);
